var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoutXpozavja(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.667 8H15m0 0l-3.733-3.733M15 8l-3.733 3.733m-2.8 3.334H1.933A.934.934 0 011 14.133v-12.2C1 1.418 1.418 1 1.933 1h6.534",
    stroke: "#fff",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTciIHZpZXdCb3g9IjAgMCAxNiAxNyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTUuNjY2NjcgOEgxNU0xNSA4TDExLjI2NjcgNC4yNjY2N00xNSA4TDExLjI2NjcgMTEuNzMzM004LjQ2NjY3IDE1LjA2NjdIMS45MzMzM0MxLjQxODEzIDE1LjA2NjcgMSAxNC42NDg1IDEgMTQuMTMzM1YxLjkzMzMzQzEgMS40MTgxMyAxLjQxODEzIDEgMS45MzMzMyAxSDguNDY2NjciIHN0cm9rZT0id2hpdGUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgLogoutXpozavja as ReactComponent };